import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "3rko0s100__mask0_9235_42323",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          fill: "#C4C4C4",
          stroke: "#152361",
          strokeWidth: "2"
        })
      }), _jsxs("g", {
        mask: "url(#3rko0s100__mask0_9235_42323)",
        children: [_jsx("rect", {
          x: "-5.70312",
          width: "42",
          height: "30",
          rx: "2",
          fill: "white"
        }), _jsx("mask", {
          id: "4wuiz4phi__mask1_9235_42323",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "-6",
          y: "0",
          width: "43",
          height: "30",
          children: _jsx("rect", {
            x: "-5.70312",
            width: "42",
            height: "30",
            rx: "2",
            fill: "white"
          })
        }), _jsxs("g", {
          mask: "url(#4wuiz4phi__mask1_9235_42323)",
          children: [_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M-5.70312 10H36.2969V0H-5.70312V10Z",
            fill: "#262626"
          }), _jsx("g", {
            filter: "url(#nby0albjc__filter0_d_9235_42323)",
            children: _jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M-5.70312 20.0001H36.2969V10.0001H-5.70312V20.0001Z",
              fill: "#F01515"
            })
          }), _jsx("g", {
            filter: "url(#09m1ct1iw__filter1_d_9235_42323)",
            children: _jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M-5.70312 29.9999H36.2969V19.9999H-5.70312V29.9999Z",
              fill: "#FFD521"
            })
          })]
        }), _jsx("path", {
          d: "M-5.70312 0V-2H-7.70312V0H-5.70312ZM36.2969 0H38.2969V-2H36.2969V0ZM36.2969 30V32H38.2969V30H36.2969ZM-5.70312 30H-7.70312V32H-5.70312V30ZM-5.70312 2H36.2969V-2H-5.70312V2ZM34.2969 0V30H38.2969V0H34.2969ZM36.2969 28H-5.70312V32H36.2969V28ZM-3.70312 30V0H-7.70312V30H-3.70312Z",
          fill: "#152361"
        }), _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      }), _jsxs("defs", {
        children: [_jsxs("filter", {
          id: "nby0albjc__filter0_d_9235_42323",
          x: "-5.70312",
          y: "10.0001",
          width: "42",
          height: "10",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [_jsx("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
          }), _jsx("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
          }), _jsx("feOffset", {}), _jsx("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          }), _jsx("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_9235_42323"
          }), _jsx("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect1_dropShadow_9235_42323",
            result: "shape"
          })]
        }), _jsxs("filter", {
          id: "09m1ct1iw__filter1_d_9235_42323",
          x: "-5.70312",
          y: "19.9999",
          width: "42",
          height: "10",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [_jsx("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
          }), _jsx("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
          }), _jsx("feOffset", {}), _jsx("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          }), _jsx("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_9235_42323"
          }), _jsx("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect1_dropShadow_9235_42323",
            result: "shape"
          })]
        })]
      })]
    }))
  });
};
export default Component;
